<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="pull-left">
                            <h4 class="card-title float-left" v-if="building.id">{{$t("building.edit.title")}}</h4>
                            <h4 class="card-title float-left" v-else>{{$t("building.edit.title")}}</h4>
                        </div>
                        <div class="pull-right d-flex align-items-center">
                            <span class="font-weight-bold mr-5">{{calculatedAll.calculated.price.expense | currency('', 2, { thousandsSeparator: ' ' })}} сум</span>
                            <button class="all-btn add-btn" @click="showCalculatedTable">Жадвал</button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>{{$t("building.field.floors")}} <span class="red">*</span></label>
                                    <numeric-input v-model="building.floors"
                                                   :class="{invalid : $v.building.floors.$error}"></numeric-input>
                                    <div class="red" v-if="$v.building.floors.$error">{{$t("building.validation.floors")}}</div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("building.field.volume")}} <span class="red">*</span></label>
                                    <numeric-input v-model="building.volume" :precision="2"
                                                   :class="{invalid : $v.building.volume.$error}"></numeric-input>
                                    <div class="red" v-if="$v.building.volume.$error">{{$t("building.validation.volume")}}</div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("building.field.buildingType")}} <span class="red">*</span></label>
                                    <v-select v-model="building.cadastreBuilding" label="name"
                                              :options="cadastreBuildings"
                                              :filterable="false"
                                              @search="onCadastreBuildingSearch"
                                              @search:focus="onCadastreBuildingFocus"
                                              :class="{invalid : $v.building.cadastreBuilding.$error}">
                                            <template slot="option" slot-scope="option" v-if="option && option.name">
                                                <div v-html="option.name" style="font-weight: bold"></div>
                                                <template v-if="option.data">
                                                    <template v-if="!option.data.capitalGroupByCategory && option.data.capitalGroup && option.data.capitalGroup.length > 0">
                                                        <div>Капиталлик гуруҳи: {{option.data.capitalGroup}}</div>
                                                    </template>
                                                    <template v-if="option.data.category && option.data.category.settings">
                                                        <template v-for="category in Object.keys(option.data.category.settings)">
                                                            <template v-if="option.data.category.settings[category].criteria && option.data.category.settings[category].criteria.length > 0">
                                                                <div :key="category">
                                                                    Категория: {{category}}. {{criteriaAsText(option.data.category.settings[category])}}
                                                                </div>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-if="option.tableInfo && option.tableInfo.length > 0">
                                                    <div>Жадвал: {{option.tableInfo}}</div>
                                                </template>
                                            </template>
                                            <template slot="selected-option" v-if="building && building.cadastreBuildings && building.cadastreBuildings.name">
                                                <div v-html="building.cadastreBuildings.name"></div>
                                            </template>
                                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.building.cadastreBuilding.$error">{{$t("building.validation.buildingType")}}</div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("building.field.buildingTypeCategory")}} <span class="red">*</span></label>
                                    <select class="form-control" v-if="isCategorySelectableAndHasCategories" v-model="building.cadastreBuildingCategory">
                                        <option value=""></option>
                                        <option :value="option" v-for="option in building.cadastreBuilding.data.category.codes" :key="option">{{option}}</option>
                                    </select>
                                    <input class="form-control" v-else :value="calculatedAll.category.code" readonly>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("building.field.name")}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="building.name"
                                           :class="{invalid : $v.building.name.$error}"/>
                                    <div class="red" v-if="$v.building.name.$error">{{$t("building.validation.name")}}</div>
                                </div>
                                <div class="form-group" v-if="hasField('madeYear')">
                                    <label>{{$t("building.field.madeYear")}} <span class="red">*</span></label>
                                    <numeric-input v-model="building.madeYear" :max="maxMadeYear"></numeric-input>
                                </div>
                                <div class="form-group" v-if="hasField('area')">
                                    <label>{{$t("building.field.area")}} <span class="red">*</span></label>
                                    <numeric-input v-model="building.area" @input="calculateVolume" :precision="2"
                                                   :class="{invalid : $v.building.area.$error}"></numeric-input>
                                    <div class="red" v-if="$v.building.area.$error">{{$t("building.validation.area")}}</div>
                                </div>
                                <div class="form-group" v-if="hasField('height')">
                                    <label>{{$t("building.field.height")}} <span class="red">*</span></label>
                                    <numeric-input v-model="building.height" @input="calculateVolume" :precision="2"
                                                   :class="{invalid : $v.building.height.$error}"></numeric-input>
                                    <div class="red" v-if="$v.building.height.$error">{{$t("building.validation.height")}}</div>
                                </div>
                                <div class="form-group" v-if="hasField('height_inner')">
                                    <label>{{$t("building.field.heightInner")}} <span class="red">*</span></label>
                                    <numeric-input v-model="building.heightInner" :precision="2"></numeric-input>
                                </div>
                                <div class="form-group" v-if="hasField('earthquake_point')">
                                    <label>{{$t("building.field.earthquakePoint")}} <span class="red">*</span></label>
                                    <select class="form-control" v-model="building.earthquakePoint"
                                            :class="{invalid : $v.building.earthquakePoint.$error}">
                                        <option :value="option.points" v-for="option in filteredEarthquakePoints" :key="option.points">{{option.points}}</option>
                                    </select>
                                    <div class="red" v-if="$v.building.earthquakePoint.$error">{{$t("building.validation.earthquakePoint")}}</div>
                                </div>
                                <div class="form-group" v-if="hasField('business_coefficient')">
                                    <label>{{$t("building.field.businessCoefficient")}} <span class="red">*</span></label>
                                    <select class="form-control" v-model="building.businessCoefficient"
                                            :class="{invalid : $v.building.businessCoefficient.$error}">
                                        <option :value="option.value" v-for="option in coefficient.business" :key="option.value">{{option.value}} ({{option.period}})</option>
                                    </select>
                                    <div class="red" v-if="$v.building.businessCoefficient.$error">{{$t("building.validation.businessCoefficient")}}</div>
                                </div>

                                <!--<div class="form-group">-->
                                    <!--<div class="form-check pl-0">-->
                                        <!--<label class="form-check-label" style="padding-left:22px !important">-->
                                            <!--<input class="form-check-input" type="checkbox" v-model="building.auxiliaryBuilding">-->
                                            <!--<span class="form-check-sign"></span>-->
                                            <!--{{$t("building.field.auxiliaryBuilding")}}-->
                                        <!--</label>-->
                                    <!--</div>-->
                                <!--</div>-->

                                <!--<div class="form-group" v-if="building.auxiliaryBuilding">-->
                                    <!--<label>{{$t("building.field.attachedTo")}} <span class="red">*</span></label>-->
                                    <!--<v-select v-model="building.parent" label="name"-->
                                              <!--:options="buildingsToAttach"-->
                                              <!--:filterable="false"-->
                                              <!--@search="onBuildingToAttachSearch"-->
                                              <!--@search:focus="onBuildingToAttachFocus"-->
                                              <!--:class="{invalid : $v.building.parent.$error}">-->
                                        <!--<span slot="no-options">{{$t("messages.combo.empty")}}</span>-->
                                    <!--</v-select>-->
                                    <!--<div class="red" v-if="$v.building.parent.$error">{{$t("building.validation.attachBuilding")}}</div>-->
                                <!--</div>-->

                                <template v-for="(field, index) in cadastreBuildingFields">
                                    <div class="form-group" :key="field.code" v-if="isLeftCustomField(field)">
                                        <label>{{field.name}} <span class="red" v-if="field.required">*</span></label>
                                        <template v-if="field.type === 'TEXT'">
                                            <input type="text" class="form-control" v-model="field.value"
                                                   :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)"/>
                                            <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customField", [field.name.toLowerCase()])}}</div>
                                        </template>
                                        <template v-else-if="field.type === 'INTEGER'">
                                            <numeric-input v-model="field.value"
                                                           :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)"></numeric-input>
                                            <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customField", [field.name.toLowerCase()])}}</div>
                                        </template>
                                        <template v-else-if="field.type === 'DECIMAL'">
                                            <numeric-input v-model="field.value" :precision="3"
                                                           :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)"></numeric-input>
                                            <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customField", [field.name.toLowerCase()])}}</div>
                                        </template>
                                        <template v-else-if="field.type === 'LISTBOX'">
                                            <select class="form-control" v-model="field.value"
                                                    :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)">
                                                <option :value="option.id" v-for="option in cadastreBuildingFieldReferences[field.reference.code]" :key="option.id">{{option.name}}</option>
                                            </select>
                                            <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                                        </template>
                                        <template v-else-if="field.type === 'COMBOBOX'">
                                            <v-select v-model="field.selected" label="name"
                                                      :options="cadastreBuildingFieldReferences[field.reference.code]"
                                                      :filterable="false"
                                                      :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)">
                                                <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                            </v-select>
                                            <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                                        </template>
                                        <template v-else-if="field.type === 'MULTISELECT'">
                                            <treeselect class="form-control" v-model="field.selected" :multiple="true"
                                                        placeholder="Танланг..."
                                                        :options="multiSelectOptions(cadastreBuildingFieldReferences[field.reference.code])"
                                                        :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @input="onFieldValueChange(field)"></treeselect>
                                            <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                                        </template>
                                        <template v-else-if="field.type === 'DATE_PICKER'">
                                            <datepicker class="form-control" format="dd/MM/yyyy" v-model="field.date" :clear-button="true"
                                                        :class="{invalid : $v.cadastreBuildingFields.$each[index].date.$error}" @change="onFieldValueChange(field)"></datepicker>
                                            <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                                        </template>
                                    </div>
                                </template>
                            </div>
                            <div class="col-12 col-md-6">
                                <template v-for="(field, index) in cadastreBuildingFields">
                                    <div class="form-group" :key="field.code" v-if="isRightCustomField(field)">
                                        <label>{{field.name}} <span class="red" v-if="field.required">*</span></label>
                                        <template v-if="field.type === 'TEXT'">
                                            <input type="text" class="form-control" v-model="field.value"
                                                   :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)"/>
                                            <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customField", [field.name.toLowerCase()])}}</div>
                                        </template>
                                        <template v-else-if="field.type === 'INTEGER'">
                                            <numeric-input v-model="field.value"
                                                           :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)"></numeric-input>
                                            <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customField", [field.name.toLowerCase()])}}</div>
                                        </template>
                                        <template v-else-if="field.type === 'DECIMAL'">
                                            <numeric-input v-model="field.value" :precision="2"
                                                           :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)"></numeric-input>
                                            <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customField", [field.name.toLowerCase()])}}</div>
                                        </template>
                                        <template v-else-if="field.type === 'LISTBOX'">
                                            <select class="form-control" v-model="field.value"
                                                    :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)">
                                                <option :value="option.id" v-for="option in cadastreBuildingFieldReferences[field.reference.code]" :key="option.id">{{option.name}}</option>
                                            </select>
                                            <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                                        </template>
                                        <template v-else-if="field.type === 'COMBOBOX'">
                                            <v-select v-model="field.selected" label="name"
                                                      :options="cadastreBuildingFieldReferences[field.reference.code]"
                                                      :filterable="false"
                                                      :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @change="onFieldValueChange(field)">
                                                <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                            </v-select>
                                            <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                                        </template>
                                        <template v-else-if="field.type === 'MULTISELECT'">
                                            <treeselect class="form-control" v-model="field.selected" :multiple="true"
                                                        placeholder="Танланг..." label="name"
                                                        :options="multiSelectOptions(cadastreBuildingFieldReferences[field.reference.code])"
                                                        :class="{invalid : $v.cadastreBuildingFields.$each[index].value.$error}" @input="onFieldValueChange(field)">
                                            </treeselect>
                                            <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                                        </template>
                                        <template v-else-if="field.type === 'DATE_PICKER'">
                                            <datepicker class="form-control" format="dd/MM/yyyy" v-model="field.date" :clear-button="true"
                                                        :class="{invalid : $v.cadastreBuildingFields.$each[index].date.$error}" @change="onFieldValueChange(field)"></datepicker>
                                            <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                                        </template>
                                    </div>
                                </template>

                                <div class="form-group" v-if="building.cadastreBuilding && building.cadastreBuilding.data
                                && building.cadastreBuilding.data.additionalValues && building.cadastreBuilding.data.additionalValues.length > 0">
                                    <label>{{$t("building.field.additionalValues")}}</label>
                                    <treeselect class="form-control" v-model="building.data.additionalValues" :multiple="true"
                                                placeholder="Танланг..." label="name"
                                                :options="preparedAdditionalValues">
                                    </treeselect>
                                </div>

                                <div class="form-group">
                                    <label>Эскириш <span class="red">*</span></label>
                                    <select class="form-control" v-model="building.technicalCondition"
                                            @change="onChangeTechnicalCondition"
                                            :class="{invalid : $v.building.technicalCondition.$error}">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in technicalConditions" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.building.technicalCondition.$error">
                                        {{$t("auto.technicalConditionOfCar")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.dilapidationValueByExpert")}} <span class="red">*</span></label>
                                    <select class="form-control" v-model="building.dilapidationValueByExpert"
                                            :class="{invalid : $v.building.dilapidationValueByExpert.$error}">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in dilapidationLookupData" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.building.dilapidationValueByExpert.$error">
                                        {{$t("auto.dilapidationValueByExpert")}}
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="row" v-if="building.cadastreBuilding">
                            <div class="col-12">
                                <div class="section-header">
                                    <h4 class="pull-left">
                                        {{$t("building.field.depreciation")}}
                                    </h4>
                                </div>
                            </div>
                            <div class="col-12 table-responsive" v-if="checkedDepreciationFields.length > 0">
                                <div class="table-wrapper">
                                  <table class="table table-striped">
                                      <thead>
                                          <tr>
                                              <th width="30%">Конструктив элемент</th>
                                              <th width="10%" class="text-right">Хисоб огирлиги</th>
                                              <th width="15%" class="text-center">Хисоб огирлигига узгартириш</th>
                                              <th width="15%" class="text-right">Кейинги хисоб огирлик</th>
                                              <th width="15%" class="text-center">Емирилиш (%)</th>
                                              <th width="15%" class="text-right" style="width: 100%;padding: 12px 8px">Хисобий емирилиш</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          <tr v-for="field in checkedDepreciationFields" :key="field.code">
                                              <td>{{field.name}}</td>
                                              <td class="text-right">{{field.weight | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-center" style="padding: 1px 8px;">
                                                  <numeric-input style="width: 100px !important; margin: 0 auto" v-model="field.change"
                                                                 :precision="2" align="center"
                                                                 :max="field.weight"></numeric-input>
                                              </td>
                                              <td class="text-right">{{field.next | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-center" style="padding: 1px 8px;">
                                                  <numeric-input style="width: 100px !important; margin: 0 auto"
                                                                 :precision="2" align="center"
                                                                 v-model="field.erosion" :max="100"></numeric-input>
                                              </td>
                                              <td class="text-right">{{field.calculated | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          </tr>
                                          <tr class="bold-row">
                                              <td>Жами:</td>
                                              <td class="text-right">{{calculatedAll.calculated.depreciation.weight | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-center">{{calculatedAll.calculated.depreciation.change |
                                                  currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-right">{{calculatedAll.calculated.depreciation.next |
                                                  currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td></td>
                                              <td class="text-right">{{calculatedAll.calculated.depreciation.calculated |
                                                  currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          </tr>
                                      </tbody>
                                  </table>
                                </div>
                            </div>
                            <div class="col-6" v-else-if="isDepreciationPercent">
                                <div class="form-group">
                                    <label>{{$t("building.field.depreciationConstructiveElements")}} <span class="red">*</span></label>
                                    <numeric-input v-model="building.depreciationPercent" :precision="2" :max="100"
                                                   :class="{invalid : $v.building.depreciationPercent.$error}"></numeric-input>
                                    <div class="red" v-if="$v.building.depreciationPercent.$error">{{$t("building.validation.depreciationPercent")}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="section-header">
                                    <h4 class="pull-left">
                                        {{$t("building.field.photosToSubmit")}}
                                    </h4>
                                </div>
                            </div>
                            <RealEstateDropZone code="buildingPhotoDropZone" folder="Building" view="BUILDING" :data="building.photos"
                                                @change="(photos) => {building.photos = photos}"
                                                :has-error="$v.building.photos.$error"/>
                        </div>

                        <div class="row">
                            <div class="col-12 text-right font-weight-bold">
                                Бинонинг харажат усулида бахоланиш киймати: {{calculatedAll.calculated.price.expense | currency('', 2, {
                                thousandsSeparator: ' ' })}} сум
                            </div>
                        </div>

                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">{{$t("action.cancel")}}</button>
                                <button class="all-btn add-btn" @click="save" :disabled="processing">{{$t("action.save")}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <RealEstateBuildingCalculatedView/>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import Treeselect from '@riophae/vue-treeselect';
    import {required, requiredUnless, minValue, minLength} from 'vuelidate/lib/validators';
    import {numericTypes} from '@/shared/constants/mask';
    import initFilterModel from '@/shared/filter';
    import RealEstateDropZone from '@/views/real-estate/RealEstateDropZone';
    import RealEstateBuildingCalculatedView from '@/views/real-estate/RealEstateBuildingCalculatedView';
    import {formatDate, parseDate} from '@/shared/utils';
    import {TECHNICAL_CONDITION} from '@/shared/constants/real-estate'
    export default {
        name: "RealEstateBuildingEdit",
        components: {
            Datepicker,
            Treeselect,
            RealEstateDropZone,
            RealEstateBuildingCalculatedView
        },
        data() {
            return {
                modelLastChangeTime: new Date().getTime(),
                numericTypes: numericTypes,
                cadastreSectionFilter: initFilterModel(),
                buildingsToAttachFilter: initFilterModel(),
                processing: false,
                realEstate: null,
                parentName: ((this.$route.params.hasOwnProperty('parentName') && this.$route.params.parentName) ? ('/' + this.$route.params.parentName + '/') : '/'),
                building: {
                    id: null,
                    realEstateId: ((this.$route.params.hasOwnProperty('realEstateId') && this.$route.params.realEstateId) ? this.$route.params.realEstateId : null),
                    cadastreBuilding: null,
                    cadastreBuildingCategory: 'a',
                    cadastreBuildingCategoryVol: null,
                    name: '',
                    madeYear: null,
                    floors: null,
                    area: null,
                    height: null,
                    heightInner: null,
                    volume: null,
                    earthquakePoint: 7,
                    businessCoefficient: 1.168,
                    depreciationPercent: 0,
                    // auxiliaryBuilding: false,
                    data: {
                        values: {},
                        additionalValues: []
                    },
                    photos: [],
                    calculated: {},
                    dilapidationValueByExpert: 0
                },
                coefficient: {
                    index: [],
                    earthquake: [],
                    regional: [],
                    capital: [],
                    height: [],
                    volume: [],
                    business: []
                },
                cadastreBuildings: [],
                cadastreBuildingFields: [],
                cadastreBuildingFieldReferences: {},
                cadastreBuildingDepreciationFields: [],
                buildingsToAttach: [],
                references: {},
                formDefault: {
                    fields: ["name", "made_year", "floors", "area", "height", "volume", "earthquake_point", "business_coefficient",
                        "foundation", "wall", "house_top", "house_cover", "floor_type", "window_and_doors", "half_timbers", "columns_and_pillars"]
                },
                maxMadeYear: new Date().getFullYear(),
                dilapidationLookupData: [],
                technicalConditions: TECHNICAL_CONDITION
            }
        },
        validations() {
            return {
                building: {
                    realEstateId: {
                        required: required
                    },
                    cadastreBuilding: {
                        required: required
                    },
                    name: {
                        required: required
                    },
                    floors: {
                        required: requiredUnless(() => {
                            return !(this.hasField('floors'));
                        }),
                        minValue: minValue(0.01)
                    },
                    area: {
                        required: requiredUnless(() => {
                            return !(this.hasField('area'));
                        }),
                        minValue: minValue(0.01)
                    },
                    height: {
                        required: requiredUnless(() => {
                            return !(this.hasField('height'));
                        }),
                        minValue: minValue(0.01)
                    },
                    volume: {
                        required: requiredUnless(() => {
                            return !(this.hasField('volume'));
                        }),
                        minValue: minValue(0.01)
                    },
                    earthquakePoint: {
                        required: requiredUnless(() => {
                            return !(this.hasField('earthquake_point'))
                        }),
                        minValue: minValue(0.01)
                    },
                    businessCoefficient: {
                        required: required,
                        minValue: minValue(0.01)
                    },
                    depreciationPercent: {
                        required: requiredUnless(() => {
                            return !(this.isDepreciationPercent);
                        })
                    },
                    photos: {
                        required: required,
                        minLength: minLength(1)
                    },
                    technicalCondition: {
                        required: required
                    },
                    dilapidationValueByExpert: {
                        required: required
                    }
                    // parent: {
                    //     required: requiredUnless(() => {
                    //         return !(this.building.auxiliaryBuilding);
                    //     })
                    // }
                },
                cadastreBuildingFields: {
                    $each: {
                        value: {
                            required: requiredUnless(vm => {
                                return !(!vm.system && this.hasField(vm.code) && vm.required);
                            })
                        }
                    }
                }
            };
        },
        computed: {
            isCategorySelectableAndHasCategories() {
                return this.building.cadastreBuilding
                    && this.building.cadastreBuilding.chooseCategory
                    && this.building.cadastreBuilding.data
                    && this.building.cadastreBuilding.data.category
                    && this.building.cadastreBuilding.data.category.codes
                    && this.building.cadastreBuilding.data.category.codes.length > 0;
            },
            checkedCustomFields() {
                return this.cadastreBuildingFields.filter((field) => {
                    return !field.system && this.hasField(field.code);
                });
            },
            checkedDepreciationFields() {
                if (this.building && this.building.cadastreBuilding && this.building.cadastreBuilding.id && this.building.cadastreBuilding.id > 0) {
                    if (this.building.cadastreBuilding.data
                        && this.building.cadastreBuilding.data.depreciation
                        && this.building.cadastreBuilding.data.depreciation.codes
                        && this.building.cadastreBuilding.data.depreciation.codes.length > 0) {
                        return this.cadastreBuildingDepreciationFields.filter((field) => {
                            return this.building.cadastreBuilding.data.depreciation.codes.includes(field.code);
                        });
                    } else {
                        return [];
                    }
                } else {
                    return [];
                }
            },
            filteredEarthquakePoints() {
                let buildingType = 'Civil';
                let buildingCategory = 'Notorious';
                let book = 1;
                if (this.building.cadastreBuilding) {
                    if (this.building.cadastreBuilding.buildingType && this.building.cadastreBuilding.buildingType.length > 0) {
                        buildingType = this.building.cadastreBuilding.buildingType;
                    }
                    if (this.building.cadastreBuilding.buildingCategory && this.building.cadastreBuilding.buildingCategory.length > 0) {
                        buildingCategory = this.building.cadastreBuilding.buildingCategory;
                    }
                    if (this.building.cadastreBuilding.cadastreSection && this.building.cadastreBuilding.cadastreSection.book) {
                        book = this.building.cadastreBuilding.cadastreSection.book;
                    }
                }
                return this.coefficient.earthquake.filter((item) => {
                    return item.type === buildingType && item.category === buildingCategory && item.book === book;
                });
            },
            preparedAdditionalValues() {
                if (this.building && this.building.cadastreBuilding && this.building.cadastreBuilding.data && this.building.cadastreBuilding.data.additionalValues) {
                    const category_code = this.calculatedAll.category.code;
                    if (category_code && category_code.length > 0) {
                        return this.building.cadastreBuilding.data.additionalValues.map((value => {
                            let label = value.name;
                            if (value.values && value.values.hasOwnProperty(category_code) && value.values[category_code]) {
                                label += '(' + value.values[category_code] + ')';
                            }
                            return {
                                id: value.code,
                                label: label
                            };
                        }));
                    }
                }
                return [];
            },
            // customDataValues() {
            //     const values = {};
            //     this.cadastreBuildingFields.forEach((field) => {
            //         if (!field.system) {
            //             if (field.type === 'COMBOBOX' || field.type === 'LISTBOX') {
            //                 if (field.selected) {
            //                     values[field.code] = {
            //                         id: field.selected.id,
            //                         code: field.selected.code
            //                     }
            //                 }
            //             } else if (field.type === 'DATE_PICKER') {
            //                 if (field.date) {
            //                     values[field.code] = formatDate(field.date);
            //                 }
            //             } else {
            //                 values[field.code] = field.value;
            //             }
            //         }
            //     });
            //     return values;
            // },
            calculatedAll() {
                //CADASTRE BUILDING CATEGORY CALCULATION
                let cbCategoryCode = '';
                let cbCategoryVol = null;
                let cbCategoryVolDefault = null;
                const cb = this.building.cadastreBuilding;
                const system_number_fields = ['made_year', 'floors', 'area', 'height', 'height_inner', 'volume'];
                const system_number_fields_code = ['madeYear', 'floors', 'area', 'height', 'heightInner', 'volume'];
                if (cb) {
                    if (cb.hasOwnProperty('chooseCategory') && cb.chooseCategory) {
                        cbCategoryCode = this.building.cadastreBuildingCategory;
                    } else if (cb.data && cb.data.category && cb.data.category.settings) {
                        Object.keys(cb.data.category.settings).forEach((category_code) => {
                            const category_settings = cb.data.category.settings[category_code];
                            const category_criteria = category_settings.criteria;
                            let category_volume = null;
                            if (category_criteria && category_criteria.length > 0) {
                                let has_not_matched_items = false;
                                category_criteria.forEach((criteria) => {
                                    const field_code = criteria.field;
                                    const field_index = system_number_fields.indexOf(field_code);
                                    if (field_index >= 0) {
                                        const value = this.building[system_number_fields_code[field_index]];
                                        if ((criteria.valueMin && value < criteria.valueMin) || (criteria.valueMax && value > criteria.valueMax)) {
                                            has_not_matched_items = true;
                                        }
                                        if (field_code === 'volume') {
                                            category_volume = criteria.valueMax;
                                            if (category_code === 'a') {
                                                cbCategoryVolDefault = criteria.valueMax;
                                            }
                                        }
                                    } else {
                                        const custom_fields = this.cadastreBuildingFields.filter((field) => field.code === field_code);
                                        if (custom_fields && custom_fields.length > 0) {
                                            const custom_field = custom_fields[0];
                                            if (this.building.data && this.building.data.values && this.building.data.values.hasOwnProperty(custom_field.code)) {
                                                const custom_field_data = this.building.data.values[custom_field.code];
                                                if (custom_field.type === 'INTEGER' || custom_field.type === 'DECIMAL') {
                                                    const value = custom_field_data;
                                                    if ((criteria.valueMin && value < criteria.valueMin) || (criteria.valueMax && value > criteria.valueMax)) {
                                                        has_not_matched_items = true;
                                                    }
                                                } else if (custom_field.type === 'COMBOBOX' || custom_field.type === 'LISTBOX') {
                                                    if (custom_field_data && custom_field_data.code) {
                                                        if (custom_field_data.code !== criteria.value) {
                                                            has_not_matched_items = true;
                                                        }
                                                    }
                                                } else {
                                                    if (custom_field_data) {
                                                        if (custom_field_data !== criteria.value) {
                                                            has_not_matched_items = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                });
                                if (!has_not_matched_items) {
                                    cbCategoryCode = category_code;
                                    cbCategoryVol = category_volume;
                                }
                            }
                        });
                    }
                }

                if (cbCategoryCode === '') {
                    cbCategoryCode = 'a';
                    cbCategoryVol = cbCategoryVolDefault;
                }

                //DEPRECIATION TOTAL CALCULATIONS
                let totalDepreciationWeight = 0;
                let totalDepreciationChange = 0;
                let totalDepreciationNext = 0;
                let totalDepreciationCalculated = 0;

                // console.log('checked_depreciation_fields_count:' + this.checkedDepreciationFields.length);

                if (this.checkedDepreciationFields.length > 0) {
                    const vm = this;
                    this.checkedDepreciationFields.forEach((field) => {
                        let weight = 0;
                        if (vm.building.cadastreBuilding && vm.building.cadastreBuilding.data && vm.building.cadastreBuilding.data.depreciation
                            && vm.building.cadastreBuilding.data.depreciation.weights
                            && vm.building.cadastreBuilding.data.depreciation.weights.hasOwnProperty(field.code)
                            && vm.building.cadastreBuilding.data.depreciation.weights[field.code]
                            && vm.building.cadastreBuilding.data.depreciation.weights[field.code].hasOwnProperty(cbCategoryCode)
                            && vm.building.cadastreBuilding.data.depreciation.weights[field.code][cbCategoryCode]) {
                            weight = vm.building.cadastreBuilding.data.depreciation.weights[field.code][cbCategoryCode];
                            // console.log('weight:' + field.name + ':' + weight);
                        }/* else {
                            console.log('weight_not_found:' + field.name);
                        }*/
                        field.weight = ((weight && weight > 0) ? weight : 0);
                        field.change = ((field.change && field.change > 0) ? field.change : 0);
                        field.next = (weight >= field.change ? (weight - field.change) : 0);

                        const dilapidation = this.building.dilapidationValueByExpert;
                        if (dilapidation && dilapidation > 0){
                            field.erosion = dilapidation;
                        } else {
                            field.erosion = 0;
                        }

                        field.calculated = (field.next * field.erosion) / 100;

                        totalDepreciationWeight += ((field.weight && field.weight > 0) ? field.weight : 0);
                        totalDepreciationChange += ((field.change && field.change > 0) ? field.change : 0);
                        totalDepreciationNext += ((field.next && field.next > 0) ? field.next : 0);
                        totalDepreciationCalculated += ((field.calculated && field.calculated > 0) ? field.calculated : 0);
                    });
                } else {
                    totalDepreciationNext = 100;
                    totalDepreciationCalculated = (this.building.depreciationPercent ? this.building.depreciationPercent : 0);
                }

                // recovery price calculation
                let recoveryPriceUnit = 'volume';
                let recoveryPriceUnitValue = null;
                let recoveryPricePerUnit = 0;
                // const categoryCode = this.building.cadastreBuildingCategory;
                if (cb && cb.data) {
                    if (cb.data.recoveryFieldCode && cb.data.recoveryFieldCode.length > 0) {
                        recoveryPriceUnit = cb.data.recoveryFieldCode;
                    }
                    if (cb.data.category && cb.data.category.settings
                        && cb.data.category.settings.hasOwnProperty(cbCategoryCode)
                        && cb.data.category.settings[cbCategoryCode] && cb.data.category.settings[cbCategoryCode].recoveryPrice) {
                        recoveryPricePerUnit = cb.data.category.settings[cbCategoryCode].recoveryPrice;
                    }
                    // if (cb.data.additionalValues && cb.data.additionalValues.length > 0) {
                    //     const addValuesChecked = cb.data.additionalValues.filter((value) => {
                    //         return this.building.data.additionalValues.indexOf(value.code) >= 0;
                    //     });
                    //     if (addValuesChecked.length > 0) {
                    //         addValuesChecked.forEach((value) => {
                    //             if (value.values && value.values.hasOwnProperty(cbCategoryCode) && value.values[cbCategoryCode] && value.values[cbCategoryCode] > 0) {
                    //                 recoveryPricePerUnit += value.values[cbCategoryCode];
                    //             }
                    //         });
                    //     }
                    // }
                }
                if (recoveryPriceUnit === 'volume') {
                    recoveryPriceUnitValue = this.building.volume;
                } else if (recoveryPriceUnit === 'height') {
                    recoveryPriceUnitValue = this.building.height;
                } else if (recoveryPriceUnit === 'height_inner') {
                    recoveryPriceUnitValue = this.building.heightInner;
                } else if (recoveryPriceUnit === 'floors') {
                    recoveryPriceUnitValue = this.building.floors;
                } else if (recoveryPriceUnit === 'area') {
                    recoveryPriceUnitValue = this.building.area;
                } else if (recoveryPriceUnit === 'earthquake_point') {
                    recoveryPriceUnitValue = this.building.earthquakePoint;
                } else if (recoveryPriceUnit === 'business_coefficient') {
                    recoveryPriceUnitValue = this.building.businessCoefficient;
                } else {
                    const custom_fields = this.cadastreBuildingFields.filter((field) => field.code === recoveryPriceUnit);
                    if (custom_fields && custom_fields.length > 0) {
                        const custom_field = custom_fields[0];
                        if ((custom_field.type === 'INTEGER' || custom_field.type === 'DECIMAL') && custom_field.value && custom_field.value > 0) {
                            recoveryPriceUnitValue = custom_field.value;
                        } else if (custom_field.type === 'LISTBOX' && custom_field.value && custom_field.value.length > 0) {
                            recoveryPriceUnitValue = parseFloat(custom_field.value);
                        } else if (custom_field.type === 'COMBOBOX' && custom_field.selected && custom_field.selected.code && custom_field.selected.code.length > 0) {
                            recoveryPriceUnitValue = parseFloat(custom_field.selected.code);
                        }
                    }
                }

                // constructive change value calculation
                let constructiveChange = (totalDepreciationNext * recoveryPricePerUnit) / 100;

                if (cb && cb.data) {
                    if (cb.data.additionalValues && cb.data.additionalValues.length > 0) {
                        const addValuesChecked = cb.data.additionalValues.filter((value) => {
                            return this.building.data.additionalValues.indexOf(value.code) >= 0;
                        });
                        if (addValuesChecked.length > 0) {
                            addValuesChecked.forEach((value) => {
                                if (value.values && value.values.hasOwnProperty(cbCategoryCode) && value.values[cbCategoryCode] && value.values[cbCategoryCode] > 0) {
                                    constructiveChange += value.values[cbCategoryCode];
                                }
                            });
                        }
                    }
                }

                // recover price 1991 calculation
                let recoveryPrice1991 = 0;
                if (recoveryPriceUnitValue) {
                    recoveryPrice1991 = constructiveChange * recoveryPriceUnitValue;
                }

                // BUILDING PRICE CALCULATION START
                // building price calculation before coefficients
                let priceBuilding = recoveryPrice1991;
                if (this.coefficient && this.coefficient.index && this.coefficient.index.length > 0) {
                    this.coefficient.index.forEach((index) => {
                        if (index.value) {
                            priceBuilding = priceBuilding * index.value;
                        }
                    });
                }
                //building price calculation - earthquake coefficient
                let book = 1;
                if (this.building.cadastreBuilding && this.building.cadastreBuilding.cadastreSection && this.building.cadastreBuilding.cadastreSection.book) {
                    book = this.building.cadastreBuilding.cadastreSection.book;
                }

                let coefficientEarthQuake = 1;

                if (this.building.cadastreBuilding && this.building.cadastreBuilding.buildingType && this.building.earthquakePoint && !this.building.cadastreBuilding.earthquakePointEnabled) {
                    const items = this.coefficient.earthquake.filter((item) => {
                        return item.type === this.building.cadastreBuilding.buildingType
                            && item.category === this.building.cadastreBuilding.buildingCategory
                            && item.points === this.building.earthquakePoint && item.book === book;
                    });
                    if (items.length > 0) {
                        coefficientEarthQuake = items[0].value;
                    }
                }
                priceBuilding = priceBuilding * coefficientEarthQuake;

                //building price calculation - regional coefficient
                let coefficientRegional = 1;
                if (this.building && this.building.cadastreBuilding && this.building.cadastreBuilding
                    && this.building.cadastreBuilding.section && this.building.cadastreBuilding.section.book
                    && this.realEstate.province && this.realEstate.province.id) {
                    const regional_items = this.coefficient.regional.filter((item) => {
                        return item.book === this.building.cadastreBuilding.section.book && item.provinceId === this.realEstate.province.id && item.book === book;
                    });
                    if (regional_items.length >= 1) {
                        coefficientRegional = regional_items[0].value;
                    }
                }
                priceBuilding = priceBuilding * coefficientRegional;

                //building price calculation - capital coefficient
                let coefficientCapital = 1;
                if (this.building && this.building.cadastreBuilding) {
                    let capitals_map = {
                        "I": {value: 1, weight : 0},
                        "II": {value: 2, weight : 0},
                        "III": {value: 3, weight : 0},
                        "IV": {value: 4, weight : 0},
                        "V": {value: 5, weight : 0}
                    };
                    let book_capital_group;
                    const cBuilding = this.building.cadastreBuilding;
                    const cBuildingCategory = this.building.cadastreBuildingCategory;
                    if (cBuilding && cBuilding.data) {
                        let capitalGroupCode;
                        if (cBuilding.data.capitalGroupByCategory) {
                            if (cBuildingCategory && cBuildingCategory.length > 0
                                && cBuilding.data.category && cBuilding.data.category.settings
                                && cBuilding.data.category.settings.hasOwnProperty(cBuildingCategory)) {
                                const categorySettings = cBuilding.data.category.settings[cBuildingCategory];
                                if (categorySettings && categorySettings.hasOwnProperty('capitalGroup')) {
                                    capitalGroupCode = categorySettings['capitalGroup'];
                                }
                            }
                        } else {
                            if (cBuilding.data.capitalGroup && cBuilding.data.capitalGroup.length > 0) {
                                capitalGroupCode = cBuilding.data.capitalGroup;
                            }
                        }
                        if (capitalGroupCode && capitalGroupCode.length > 0 && capitals_map.hasOwnProperty(capitalGroupCode)) {
                            book_capital_group = capitals_map[capitalGroupCode].value;
                        }
                    }

                    if (book_capital_group && book_capital_group > 0) {
                        let calculated_max_weight = 0;
                        let calculated_capital_group;

                        let capitals_key = 'capitals';
                        if (this.building.cadastreBuilding && this.building.cadastreBuilding.buildingCategory
                            && this.building.cadastreBuilding.buildingCategory === 'Residential') {
                            capitals_key = 'capitals_residential';
                        }

                        this.cadastreBuildingFields.forEach((field) => {
                            if (field.data && field.data.values && field.data.values.hasOwnProperty('capital_weight')) {
                                const weight = field.data.values['capital_weight'];
                                if (field.selected && field.selected.data && field.selected.data.values && field.selected.data.values.hasOwnProperty(capitals_key)) {
                                    const capitals = field.selected.data.values[capitals_key];
                                    if (capitals && capitals.length > 0) {
                                        capitals.forEach((capital) => {
                                            if (capitals_map.hasOwnProperty(capital)) {
                                                capitals_map[capital].weight += weight;
                                                if (capitals_map[capital].weight > calculated_max_weight) {
                                                    calculated_max_weight = capitals_map[capital].weight;
                                                    calculated_capital_group = capitals_map[capital].value
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        });
                        if (!calculated_capital_group) {
                            calculated_capital_group = book_capital_group;
                        }
                        if (calculated_capital_group) {
                            let building_category = 'Notorious';
                            if (this.building.cadastreBuilding && this.building.cadastreBuilding.buildingCategory
                                && this.building.cadastreBuilding.buildingCategory.length > 0) {
                                building_category = this.building.cadastreBuilding.buildingCategory;
                            }
                            const capital_items = this.coefficient.capital.filter((item) => {
                                return item.bookGroup === book_capital_group
                                    && item.buildingGroup === calculated_capital_group
                                    && item.category === building_category;
                            });
                            if (capital_items.length > 0) {
                                coefficientCapital = capital_items[0].value;
                            }
                        }
                    }
                }
                priceBuilding = priceBuilding * coefficientCapital;

                //building price calculation - height coefficient
                let coefficientHeight = 1;
                if (this.building.cadastreBuilding && this.building.cadastreBuilding.buildingType
                    && this.building.cadastreBuilding.buildingType === 'Civil'
                    && this.building.heightInner && this.building.heightInner > 0) {
                    let lastAcceptableHeight;
                    this.coefficient.height.forEach((height) => {
                        if (height.height <= this.building.heightInner) {
                            lastAcceptableHeight = height;
                        } else {
                            coefficientHeight = 1.06
                        }
                    });
                    if (lastAcceptableHeight) {
                        coefficientHeight = lastAcceptableHeight.value;
                    }
                }
                priceBuilding = priceBuilding * coefficientHeight;

                //building price calculation - volume coefficient
                let coefficientVolume = 1;
                if (this.building.cadastreBuildingCategoryVol && this.building.cadastreBuildingCategoryVol >= 0 && this.building.volume && this.building.volume >= 0) {
                    this.coefficient.volume.forEach((bookVol) => {
                        if (this.building.cadastreBuildingCategoryVol >= bookVol.min && this.building.cadastreBuildingCategoryVol <= bookVol.max) {
                            if (bookVol.items && bookVol.items.length > 0) {
                                bookVol.items.forEach((evlVol) => {
                                    if (this.building.volume >= evlVol.min && this.building.volume <= evlVol.max) {
                                        coefficientVolume = evlVol.coefficient;
                                    }
                                });
                            }
                        }
                    });
                }
                priceBuilding = priceBuilding * coefficientVolume;

                // //building price calculation - business coefficient
                priceBuilding = priceBuilding * this.building.businessCoefficient;
                // BUILDING PRICE CALCULATION END

                //DEPRECIATION CALCULATION START
                let calculatedDepreciationPercent = 0;
                let calculatedDepreciationTotal = 0;
                if (totalDepreciationNext && totalDepreciationNext > 0) {
                    // calculatedDepreciationPercent = totalDepreciationCalculated * 100 / totalDepreciationNext;
                    calculatedDepreciationPercent = totalDepreciationCalculated;
                    calculatedDepreciationTotal = priceBuilding * calculatedDepreciationPercent / 100;
                }
                //DEPRECIATION CALCULATION END

                // //PRICE CALCULATION - EXPENSE METHOD
                const priceExpense = priceBuilding - calculatedDepreciationTotal;

                return {
                    modelLastChangeTime: this.modelLastChangeTime,
                    category: {
                        code: cbCategoryCode,
                        volume: cbCategoryVol
                    },
                    calculated: {
                        constructive: {
                            change: constructiveChange
                        },
                        recovery: {
                            unit: 'volume',
                            pricePerUnit: recoveryPricePerUnit,
                            price1991: recoveryPrice1991
                        },
                        coefficient: {
                            earthquake: coefficientEarthQuake,
                            regional: coefficientRegional,
                            capital: coefficientCapital,
                            height: coefficientHeight,
                            volume: coefficientVolume,
                            business: this.building.businessCoefficient
                        },
                        depreciation: {
                            weight: totalDepreciationWeight,
                            change: totalDepreciationChange,
                            next: totalDepreciationNext,
                            calculated: totalDepreciationCalculated,
                            percent: calculatedDepreciationPercent,
                            total: calculatedDepreciationTotal
                        },
                        price: {
                            building: priceBuilding,
                            expense: priceExpense,
                            income: 0,
                            comparative: 0
                        }
                    }
                };
            },
            isDepreciationPercent() {
                return  this.building
                        && this.building.cadastreBuilding
                        && this.building.cadastreBuilding.id
                        && this.building.cadastreBuilding.id > 0
                        && this.building.cadastreBuilding.totalDepreciation;
            }
        },
        methods: {
            init() {
                const vm = this;
                const promises = [
                    this.$http.get('real-estate/' + this.building.realEstateId + '/building/init')
                ];
                if (this.$route.params.hasOwnProperty('buildingId') && this.$route.params.buildingId && this.$route.params.buildingId > 0) {
                    promises.push(this.$http.get('real-estate/building/' + this.$route.params.buildingId));
                }
                Promise.all(promises).then(function(values) {
                    const initData = values[0].data;
                    vm.realEstate = initData.realEstate;
                    vm.coefficient = initData.coefficient;
                    vm.cadastreBuildingFields = initData.fields;
                    vm.cadastreBuildingFieldReferences = initData.references;
                    vm.cadastreBuildingDepreciationFields = initData.depreciation.map((field) => {
                        field.weight = 0;
                        field.change = 0;
                        field.erosion = 0;
                        return field;
                    });

                    if (values.length >= 2) {
                        const formData = values[1].data;
                        if (formData && formData.settings && formData.settings.indexes && formData.settings.indexes.length > 0) {
                            vm.coefficient.index = formData.settings.indexes;
                        }
                        // if (formData.parent && formData.parent.id && formData.parent.id > 0) {
                        //     formData.auxiliaryBuilding = true;
                        // }
                        if (formData.data && formData.data.values) {
                            vm.cadastreBuildingFields.forEach((field) => {
                                if (field.code && !field.system && formData.data.values.hasOwnProperty(field.code)) {
                                    const fieldValue = formData.data.values[field.code];
                                    if (fieldValue) {
                                        if (field.type === 'COMBOBOX' || field.type === 'LISTBOX') {
                                            if (fieldValue.id && fieldValue.id > 0) {
                                                field.value = fieldValue.id;
                                                field.selected = vm.getReferenceById(field.reference.code, fieldValue.id);
                                            }
                                        } else if (field.type === 'MULTISELECT') {
                                            if (fieldValue) {
                                                field.selected = [];
                                                if (fieldValue.length > 0) {
                                                    fieldValue.forEach((ref) => {
                                                        field.selected.push(ref.id);
                                                    });
                                                } else if (fieldValue.hasOwnProperty('id') && fieldValue.id && fieldValue.id > 0) {
                                                    field.selected.push(fieldValue.id);
                                                }
                                                field.value = field.selected;
                                            }
                                        } else if (field.type === 'DATE_PICKER') {
                                            if (fieldValue) {
                                                field.date = parseDate(fieldValue);
                                            }
                                        } else {
                                            field.value = fieldValue;
                                        }
                                    }
                                }
                            });
                            if (formData.depreciations && formData.depreciations.length > 0) {
                                vm.cadastreBuildingDepreciationFields.forEach((field) => {
                                    formData.depreciations.forEach((depreciation) => {
                                        if (depreciation.field && depreciation.field.id && depreciation.field.id === field.id) {
                                            field.weight = depreciation.weight;
                                            field.change = depreciation.change;
                                            field.erosion = depreciation.erosion;
                                        }
                                    });
                                });
                            }
                        }
                        if (!formData.data) {
                            formData.data = {};
                        }
                        if (!formData.data.values) {
                            formData.data.values = {};
                        }
                        if (!formData.data.additionalValues) {
                            formData.data.additionalValues = [];
                        }
                        vm.building = formData;
                    }
                    vm.onChangeTechnicalCondition();
                });
            },
            cancel() {
                this.$router.push(this.parentName + 'real-estate/edit/' + this.building.realEstateId);
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                // this.building.data = {
                //     values: this.customDataValues
                // };

                // if (!this.building.auxiliaryBuilding) {
                //     this.building.parent = null;
                // }

                this.building.depreciations = [];
                this.checkedDepreciationFields.forEach((field) => {
                    this.building.depreciations.push({
                        field: {
                            id: field.id,
                        },
                        weight: field.weight,
                        change: field.change,
                        next: field.next,
                        erosion: field.erosion,
                        calculated: field.calculated
                    });
                });
                this.building.cadastreBuildingCategory = this.calculatedAll.category.code;
                this.building.cadastreBuildingCategoryVol = this.calculatedAll.category.volume;
                this.building.calculated = this.calculatedAll.calculated;

                if (!this.building.settings) {
                    this.building.settings = {};
                }
                this.building.settings.indexes = this.coefficient.index;

                this.$http.post('real-estate/building', this.building)
                    .then(res => {
                        if (res.data && res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.building.success'),
                                type: 'success'
                            });
                            this.$router.push(this.parentName + 'real-estate/edit/' + this.building.realEstateId);
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.building.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            },
            multiSelectOptions(options) {
                const items = [];
                if (options && options.length > 0) {
                    options.forEach((option) => {
                        items.push({
                            id: option.id,
                            label: option.name
                        });
                    });
                }
                return items;
            },
            calculateVolume() {
                if (this.building.area && this.building.area > 0 && this.building.height && this.building.height > 0) {
                    this.building.volume = this.building.area * this.building.height;
                }
            },
            showCalculatedTable() {
                this.building.cadastreBuildingCategory = this.calculatedAll.category.code;
                this.building.cadastreBuildingCategoryVol = this.calculatedAll.category.volume;
                this.building.calculated = this.calculatedAll.calculated;

                const fields = this.checkedCustomFields;
                fields.forEach((field) => {
                    if (field.type && field.type === 'MULTISELECT') {
                        if (field.value && field.value.length > 0) {
                            let valueAsLabel = '';
                            field.value.forEach((option_id) => {
                                const optionSelected = this.getReferenceById(field.reference.code, option_id);
                                if (optionSelected && optionSelected.name && optionSelected.name.length > 0) {
                                    if (valueAsLabel.length > 0) {
                                        valueAsLabel += ', ';
                                    }
                                    valueAsLabel += optionSelected.name;
                                }
                            });
                            field.valueAsLabel = valueAsLabel;
                        }
                    }
                });

                const data = {
                    realEstate: this.realEstate,
                    building: this.building,
                    coefficient: this.coefficient,
                    fields: fields,
                    depreciationFields: this.checkedDepreciationFields
                };
                this.$eventBus.$emit('showRealEstateBuildingCalculatedTable', data);
            },
            onCadastreBuildingSearch(searchTxt, loading) {
                loading(true);
                this.cadastreBuildings = [];
                this.cadastreSectionFilter.page.size = 1000;
                this.cadastreSectionFilter.realEstateId = this.building.realEstateId;
                this.cadastreSectionFilter.search = searchTxt;
                this.cadastreSectionFilter.volume = this.building.volume;
                this.cadastreSectionFilter.floors = this.building.floors;
                this.$http.post('cadastre/building/search', this.cadastreSectionFilter)
                    .then(res => {
                        this.cadastreBuildings = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onCadastreBuildingFocus() {
                this.cadastreBuildings = [];
                this.cadastreSectionFilter.page.size = 1000;
                this.cadastreSectionFilter.realEstateId = this.building.realEstateId;
                this.cadastreSectionFilter.search = '';
                this.cadastreSectionFilter.volume = this.building.volume;
                this.cadastreSectionFilter.floors = this.building.floors;
                this.$http.post('cadastre/building/search', this.cadastreSectionFilter)
                    .then(res => {
                        this.cadastreBuildings = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onBuildingToAttachSearch(searchTxt, loading) {
                loading(true);
                this.buildingsToAttach = [];
                this.buildingsToAttachFilter.search = searchTxt;
                if (this.building.id && this.building.id > 0) {
                    this.buildingsToAttachFilter.excluded = [this.building.id];
                }
                this.$http.post('real-estate/' + this.building.realEstateId + '/building/search', this.buildingsToAttachFilter)
                    .then(res => {
                        this.buildingsToAttach = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onBuildingToAttachFocus () {
                this.buildingsToAttach = [];
                this.buildingsToAttachFilter.search = '';
                if (this.building.id && this.building.id > 0) {
                    this.buildingsToAttachFilter.excluded = [this.building.id];
                }
                this.$http.post('real-estate/' + this.building.realEstateId + '/building/search', this.buildingsToAttachFilter)
                    .then(res => {
                        this.buildingsToAttach = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            hasField(code) {
                if (this.building && this.building.cadastreBuilding && this.building.cadastreBuilding.id && this.building.cadastreBuilding.id > 0) {
                    if (this.building.cadastreBuilding.data && this.building.cadastreBuilding.data.fields && this.building.cadastreBuilding.data.fields.length > 0) {
                        return this.building.cadastreBuilding.data.fields.includes(code);
                    } else {
                        return false;
                    }
                } else {
                    return this.formDefault.fields.includes(code);
                }
            },
            isLeftCustomField(field) {
                return !field.system && field.alignment === 1 && this.hasField(field.code);
            },
            isRightCustomField(field) {
                return !field.system && field.alignment === 2 && this.hasField(field.code);
            },
            getReferenceById(code, id) {
                if (this.cadastreBuildingFieldReferences.hasOwnProperty(code)) {
                    const fieldReferences = this.cadastreBuildingFieldReferences[code];
                    const references = fieldReferences.filter((ref) => {
                        return ref.id === id
                    });
                    return references.length > 0 ? references[0] : null;
                } else {
                    return null;
                }
            },
            onFieldValueChange(field) {
                if (!field.system) {
                    let fieldValue = {};
                    if (field.type === 'COMBOBOX' || field.type === 'LISTBOX') {
                        if (field.type === 'LISTBOX') {
                            field.selected = this.getReferenceById(field.reference.code, field.value);
                        }
                        if (field.selected) {
                            fieldValue = {
                                id: field.selected.id,
                                code: field.selected.code
                            }
                        }
                        if (field.type === 'COMBOBOX') {
                            field.value = fieldValue;
                        }
                    } else if (field.type === 'MULTISELECT') {
                        fieldValue = [];
                        if (field.selected && field.selected.length > 0) {
                            field.selected.forEach((ref_id) => {
                                const ref = this.getReferenceById(field.reference.code, ref_id);
                                if (ref) {
                                    fieldValue.push({
                                        id: ref.id,
                                        code: ref.code
                                    })
                                }
                            });
                        }
                        field.value = fieldValue;
                    } else if (field.type === 'DATE_PICKER') {
                        if (field.date) {
                            fieldValue = formatDate(field.date);
                        }
                    } else {
                        fieldValue = field.value;
                    }
                    this.building.data.values[field.code] = fieldValue;
                    this.modelLastChangeTime = new Date().getTime();
                }
            },
            getFieldByCode(field_code) {
                const fields = this.cadastreBuildingFields.filter((field) => {
                    return field.code === field_code;
                });
                return (fields && fields.length > 0) ? fields[0] : null;
            },
            criteriaAsText(category_settings) {
                let text = "";
                if (category_settings) {
                    if (category_settings.hasOwnProperty('criteria')) {
                        const criteria_list = category_settings.criteria;
                        if (criteria_list && criteria_list.length > 0) {
                            criteria_list.forEach((criteria) => {
                                if (criteria && criteria.field) {
                                    const field = this.getFieldByCode(criteria.field);
                                    if (field) {
                                        if (criteria.valueMin || criteria.valueMax) {
                                            text += (field.name + ': ' + ((criteria.valueMin ? criteria.valueMin : '0.00') + ' - ' + (criteria.valueMax ? criteria.valueMax : '120 000.00')) + '. ');
                                        } else if (criteria.valueId) {
                                            const reference = this.getReferenceById(field.code, criteria.valueId);
                                            if (reference) {
                                                text += (' ' + field.name + ': ' + reference.name + '. ');
                                            }
                                        } else if (criteria.value) {
                                            text += (' ' + field.name + ': ' + criteria.value + '. ');
                                        }
                                    }
                                }
                            });
                        }
                        if (category_settings.capitalGroup && category_settings.capitalGroup.length > 0) {
                            text += (' Капиталлик гуруҳи: ' + category_settings.capitalGroup + '. ');
                        }
                    }
                }
                return text;
            },
            onChangeTechnicalCondition() {
                this.dilapidationLookupData = [];
                if (this.building.technicalCondition === "GOOD") {
                    this.dilapidationLookupData = [{key: "5", name: "5 %"},{key: "10", name: "10 %"},{key: "15", name: "15 %"},{key: "20", name: "20 %"}];
                } else if (this.building.technicalCondition === "SATISFACTORY") {
                    this.dilapidationLookupData = [{key: "25", name: "25 %"},{key: "30", name: "30 %"},{key: "35", name: "35 %"},{key: "40", name: "40 %"}];
                } else if (this.building.technicalCondition === "DISSATISFIED") {
                    this.dilapidationLookupData = [{key: "45", name: "45 %"},{key: "50", name: "50 %"},{key: "55", name: "55 %"},{key: "60", name: "60 %"}];
                } else if (this.building.technicalCondition === "ACCIDENT_STATE") {
                    this.dilapidationLookupData = [{key: "65", name: "65 %"},{key: "70", name: "70 %"},{key: "75", name: "75 %"},{key: "80", name: "80 %"}];
                } else if (this.building.technicalCondition === "UNUSABLE") {
                    this.dilapidationLookupData = [{key: "85", name: "85 %"},{key: "90", name: "90 %"},{key: "95", name: "95 %"},{key: "100", name: "100 %"}];
                } else {
                    this.building.dilapidationValueByExpert = 0;
                }
            }
        },
        created() {
            this.init();
        }
    }
</script>

<style>

</style>
